import React from 'react';
import { Info } from 'lucide-react';
import { formatPhone } from '@/utils/formatPhone';

interface JobGeneralInfoProps {
    customerName: string;
    setCustomerName: (val: string) => void;
    customerPhone: string;
    setCustomerPhone: (val: string) => void;
    address: string;
    setAddress: (val: string) => void;
    city: string;
    setCity: (val: string) => void;
    state: string;
    setState: (val: string) => void;
    zip: string;
    setZip: (val: string) => void;
    county: string;
    setCounty: (val: string) => void;
    fnolReceivedDate: string;
    setFnolReceivedDate: (val: string) => void;
}

export const JobGeneralInfo: React.FC<JobGeneralInfoProps> = ({
    customerName, setCustomerName,
    customerPhone, setCustomerPhone,
    address, setAddress,
    city, setCity,
    state, setState,
    zip, setZip,
    county, setCounty,
    fnolReceivedDate, setFnolReceivedDate
}) => {
    return (
        <div className="space-y-6">
            <div className="flex items-center gap-2 text-accent-electric mb-4">
                <Info size={18} />
                <h3 className="text-sm font-black uppercase tracking-widest">General Info</h3>
            </div>

            {/* Customer Name */}
            <div className="space-y-1">
                <label className="text-micro font-bold text-text-muted uppercase">Customer Name</label>
                <input
                    placeholder="Full Name"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    required
                    className="input-field"
                />
            </div>

            {/* Address Block */}
            <div className="space-y-2 bg-surface-hover p-4 rounded-xl border border-divider-subtle">
                <label className="text-micro font-bold text-text-muted uppercase">Property Address</label>
                <input
                    placeholder="Street Address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    className="input-field mb-2"
                />
                <div className="grid grid-cols-2 gap-2">
                    <input placeholder="City" value={city} onChange={(e) => setCity(e.target.value)} className="input-field" />
                    <input placeholder="State" value={state} onChange={(e) => setState(e.target.value)} className="input-field" />
                </div>
                <div className="grid grid-cols-2 gap-2">
                    <input placeholder="ZIP" value={zip} onChange={(e) => setZip(e.target.value)} className="input-field" />
                    <input placeholder="County" value={county} onChange={(e) => setCounty(e.target.value)} className="input-field" />
                </div>
            </div>

            {/* Phone and Date */}
            <div className="grid grid-cols-2 gap-4">
                <div className="space-y-1">
                    <label className="text-micro font-bold text-text-muted uppercase">Phone Number</label>
                    <input
                        type="tel"
                        placeholder="(555) 555-5555"
                        value={customerPhone}
                        onChange={(e) => setCustomerPhone(formatPhone(e.target.value))}
                        className="input-field"
                    />
                </div>
                <div className="space-y-1">
                    <label className="text-micro font-bold text-text-muted uppercase">Job Received Date</label>
                    <input
                        type="date"
                        value={fnolReceivedDate}
                        onChange={(e) => setFnolReceivedDate(e.target.value)}
                        className="input-field"
                    />
                </div>
            </div>
        </div>
    );
};
